// src/boot-entry.ts
/**
 * The one line that pulls the trigger.
 *
 * Separate from `boot.ts` so that module stays importable by a unit test: a
 * module whose IMPORT boots a page cannot be tested without pretending to be a
 * browser, and the menu's entry list is exactly the thing worth testing.
 */
import { boot } from "./boot.js";

boot();
